import { Jumbotron as _Jumbotron, JumbotronProps as _JumbotronProps } from "reactstrap";

    export const Jumbotron = _Jumbotron;
    export type JumbotronProps = _JumbotronProps;
    